import { Helpers } from '../../helpers';
import { IResourceType } from '../../interfaces/iresource-type';
import { ResourceLevelingSetting } from '../resource-leveling-setting';

export class ResourceTypeBase {
  ResourceTypeId: number;
  Description: string | null;
  DetailType: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ResourceLevelingSettings_ResourceType?: Array<ResourceLevelingSetting> | null;

  constructor(item?: IResourceType) {
    if (item) {

      this.ResourceTypeId = item.ResourceTypeId;
      this.Description = item.Description;
      this.DetailType = item.DetailType;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ResourceLevelingSettings_ResourceType = Helpers.createClassArray(ResourceLevelingSetting, item.ResourceLevelingSettings_ResourceType);
    }
  }
}